 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		4: 0
 	};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		4: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"framework","1":"commons","2":"styles","3":"aeee8fc03997ab33ce871b5eef66b1bbe90f4b38","7":"component---src-pages-404-js","8":"component---src-pages-about-js","9":"component---src-pages-all-js","10":"component---src-pages-baby-accessories-js","11":"component---src-pages-baby-toys-js","12":"component---src-pages-basket-js","13":"component---src-pages-bath-time-hampers-js","14":"component---src-pages-bathtime-accessories-js","15":"component---src-pages-best-sellers-js","16":"component---src-pages-blankets-js","17":"component---src-pages-boys-js","18":"component---src-pages-build-js","19":"component---src-pages-clothing-js","20":"component---src-pages-comforters-js","21":"component---src-pages-contact-js","22":"component---src-pages-cosy-hampers-js","23":"component---src-pages-eco-hampers-js","24":"component---src-pages-girls-js","25":"component---src-pages-index-js","26":"component---src-pages-letterbox-gifts-js","27":"component---src-pages-new-arrivals-js","28":"component---src-pages-new-parent-hampers-js","29":"component---src-pages-onesie-sets-js","30":"component---src-pages-personalised-accessories-js","31":"component---src-pages-personalised-bibs-js","32":"component---src-pages-personalised-blankets-js","33":"component---src-pages-personalised-clothing-js","34":"component---src-pages-personalised-comforters-js","35":"component---src-pages-personalised-hampers-js","36":"component---src-pages-product-js","37":"component---src-pages-refunds-js","38":"component---src-pages-sale-js","39":"component---src-pages-spring-summer-js","40":"component---src-pages-suitcases-js","41":"component---src-pages-unisex-js","42":"component---src-pages-winter-warmers-js","43":"component---src-pages-xchristmas-js"}[chunkId]||chunkId) + "-" + {"0":"d80c69f8af727a12805a","1":"a547ed5e534c8068f50a","2":"7d4153d260c0197f0043","3":"ed2787158e66f198e450","7":"f4e91acbe7fa52a1678f","8":"8db0cdf2f5a6863a4f36","9":"69b404122eabb4400328","10":"0d12ec81431079ad2937","11":"fbcc80c67fe472daf26f","12":"0f02d13d9fefd08f3f3d","13":"b4d831b4ebc7e126574f","14":"73ce3ee51136821ed3fc","15":"4f1652f1c35657fcafdc","16":"5d0fce3ff8ea78913e87","17":"cc74bd503f2a2efbf552","18":"3119f70770a954851d6e","19":"2dd1976f143375d45a3b","20":"1b42828b4e9b520f85f0","21":"c4d8c54fe142a300d699","22":"17fc375c1f1b71ea673b","23":"0fab00ea045227065e2f","24":"49dd8cec8efe3c7e9bb0","25":"b59b0b9bebcf2ef2303d","26":"272219a6cf52927dfa91","27":"d3b9901d6575a7e2f4af","28":"cc11199809db8453545c","29":"b3269e129ade62d34839","30":"7d9be4deab38f40a51f0","31":"b8981648d1bbd0e0ab6e","32":"caafc3e7c726e285de0c","33":"0ce8756466f658f0f6b4","34":"63fbdfbbe0e688b3a7a8","35":"92a23e3031677d3e2b0c","36":"53aea4f6077af712d8ce","37":"b571a2e6c8ffc6a102e3","38":"0bb87b71b30ce25503f4","39":"4cda60f0bd21509fd799","40":"3d0ae19fdca2e28cc11a","41":"17cb763294d25ebd45b2","42":"f0e2cb4fa30015a48e3d","43":"8ad3c08577e76eb2530c"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"2":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "" + ({"0":"framework","1":"commons","2":"styles","3":"aeee8fc03997ab33ce871b5eef66b1bbe90f4b38","7":"component---src-pages-404-js","8":"component---src-pages-about-js","9":"component---src-pages-all-js","10":"component---src-pages-baby-accessories-js","11":"component---src-pages-baby-toys-js","12":"component---src-pages-basket-js","13":"component---src-pages-bath-time-hampers-js","14":"component---src-pages-bathtime-accessories-js","15":"component---src-pages-best-sellers-js","16":"component---src-pages-blankets-js","17":"component---src-pages-boys-js","18":"component---src-pages-build-js","19":"component---src-pages-clothing-js","20":"component---src-pages-comforters-js","21":"component---src-pages-contact-js","22":"component---src-pages-cosy-hampers-js","23":"component---src-pages-eco-hampers-js","24":"component---src-pages-girls-js","25":"component---src-pages-index-js","26":"component---src-pages-letterbox-gifts-js","27":"component---src-pages-new-arrivals-js","28":"component---src-pages-new-parent-hampers-js","29":"component---src-pages-onesie-sets-js","30":"component---src-pages-personalised-accessories-js","31":"component---src-pages-personalised-bibs-js","32":"component---src-pages-personalised-blankets-js","33":"component---src-pages-personalised-clothing-js","34":"component---src-pages-personalised-comforters-js","35":"component---src-pages-personalised-hampers-js","36":"component---src-pages-product-js","37":"component---src-pages-refunds-js","38":"component---src-pages-sale-js","39":"component---src-pages-spring-summer-js","40":"component---src-pages-suitcases-js","41":"component---src-pages-unisex-js","42":"component---src-pages-winter-warmers-js","43":"component---src-pages-xchristmas-js"}[chunkId]||chunkId) + "." + {"0":"31d6cfe0d16ae931b73c","1":"31d6cfe0d16ae931b73c","2":"aa88c73e140fde43a7ff","3":"31d6cfe0d16ae931b73c","7":"31d6cfe0d16ae931b73c","8":"31d6cfe0d16ae931b73c","9":"31d6cfe0d16ae931b73c","10":"31d6cfe0d16ae931b73c","11":"31d6cfe0d16ae931b73c","12":"31d6cfe0d16ae931b73c","13":"31d6cfe0d16ae931b73c","14":"31d6cfe0d16ae931b73c","15":"31d6cfe0d16ae931b73c","16":"31d6cfe0d16ae931b73c","17":"31d6cfe0d16ae931b73c","18":"31d6cfe0d16ae931b73c","19":"31d6cfe0d16ae931b73c","20":"31d6cfe0d16ae931b73c","21":"31d6cfe0d16ae931b73c","22":"31d6cfe0d16ae931b73c","23":"31d6cfe0d16ae931b73c","24":"31d6cfe0d16ae931b73c","25":"31d6cfe0d16ae931b73c","26":"31d6cfe0d16ae931b73c","27":"31d6cfe0d16ae931b73c","28":"31d6cfe0d16ae931b73c","29":"31d6cfe0d16ae931b73c","30":"31d6cfe0d16ae931b73c","31":"31d6cfe0d16ae931b73c","32":"31d6cfe0d16ae931b73c","33":"31d6cfe0d16ae931b73c","34":"31d6cfe0d16ae931b73c","35":"31d6cfe0d16ae931b73c","36":"31d6cfe0d16ae931b73c","37":"31d6cfe0d16ae931b73c","38":"31d6cfe0d16ae931b73c","39":"31d6cfe0d16ae931b73c","40":"31d6cfe0d16ae931b73c","41":"31d6cfe0d16ae931b73c","42":"31d6cfe0d16ae931b73c","43":"31d6cfe0d16ae931b73c"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
